import { useId } from 'react';
import Filters from 'src/components/form/filters/filters';
import { searchInputValidationSchema } from 'src/components/form/search/filters-form/helper';
import SearchInput from 'src/components/form/search/filters-form/search-input';
import { ContactFormProps, SearchFormProps } from 'src/types';
import css from '../contacts.module.scss';

export default function SearchForm({ onSubmit, initialValues }: Readonly<SearchFormProps<ContactFormProps>>) {
  const inputId = useId();

  return (
    <Filters
      initialFilters={initialValues}
      onSearch={onSubmit}
      validationSchema={searchInputValidationSchema('search')}
      fieldsToSubmitOnChange={['search']}
      render={({ errors, _, registerAndClearOnChange }) => (
        <div className={css.filtersGroup}>
          <SearchInput
            id={inputId}
            name='search'
            placeholder='Шукати контакт'
            inputProps={registerAndClearOnChange('search')}
            error={errors?.search?.message}
          />
        </div>
      )}
    />
  );
}
